export const aicardInfo = [
    {
      id: 1,
      count: 1,
      link: 'https://istorage.cloud.googie.com/ai',
      pdfFileName: 'goog-10-k-q4-2022.pdf',
      text: "• seasonality. Additionally, fluctuations in our revenues generated from advertising (Google advertising*), revenues from other sources ",
    },
    {
      id: 2,
      count: 2,
      link: 'https://istorage.cloud.googie.com/ai',
      pdfFileName: 'goog-10-k-q4-2022.pdf',
      text: "• seasonality. Additionally, fluctuations in our revenues generated from advertising (Google advertising*), revenues from other sources ",
    },
    {
        id: 3,
        count: 2,
        link: 'https://istorage.cloud.googie.com/ai',
        pdfFileName: 'goog-10-k-q4-2022.pdf',
        text: "• seasonality. Additionally, fluctuations in our revenues generated from advertising (Google advertising*), revenues from other sources ",
      },
      {
        id: 4,
        count: 2,
        link: 'https://istorage.cloud.googie.com/ai',
        pdfFileName: 'goog-10-k-q4-2022.pdf',
        text: "• seasonality. Additionally, fluctuations in our revenues generated from advertising (Google advertising*), revenues from other sources ",
      },
      {
        id: 5,
        count: 2,
        link: 'https://istorage.cloud.googie.com/ai',
        pdfFileName: 'goog-10-k-q4-2022.pdf',
        text: "• seasonality. Additionally, fluctuations in our revenues generated from advertising (Google advertising*), revenues from other sources ",
      },
      {
        id: 6,
        count: 2,
        link: 'https://istorage.cloud.googie.com/ai',
        pdfFileName: 'goog-10-k-q4-2022.pdf',
        text: "• seasonality. Additionally, fluctuations in our revenues generated from advertising (Google advertising*), revenues from other sources ",
      },
  ]